export default __webpack_public_path__ + "static/media/hazard.cac36a8f.svg";